import configTypes from '../types/config';
import paymentTypes from "../types/payment";

const initialStore = {
  isMenuOpen: false,
  formTopic: '',
  formTopicError: '',
  formPolicy: '',
  formPolicyError: '',
  formName: '',
  formNameError: '',
  formAgencyName: '',
  formAgencyNameError: '',
  formEmail: '',
  formEmailError: '',
  formPhone: '',
  formPhoneError: '',
  formMessage: '',
  formMessageError: '',
  formCity: '',
  formCityError: '',
  formStreet: '',
  formStreetError: '',
  formZip: '',
  formZipError: '',
  modalSuccessOpen: false,
  isLoading: false,
  isContactUsLoading: false,
  isContactAgentLoading: false,
  isBecomeAgentLoading: false,
  isApplyFormLoading: false,
};

const configStore = (state = initialStore, action) => {
  switch (action.type) {
    case configTypes.SET_MENU_OPEN:
      return {
        ...state,
        isMenuOpen: action.bool,
      };
    case configTypes.SET_FORM_TOPIC:
      return {
        ...state,
        formTopic: action.string,
      };
    case configTypes.SET_FORM_TOPIC_ERROR:
      return {
        ...state,
        formTopicError: action.string,
      };
    case configTypes.SET_FORM_POLICY:
      return {
        ...state,
        formPolicy: action.string,
      };
    case configTypes.SET_FORM_POLICY_ERROR:
      return {
        ...state,
        formPolicyError: action.string,
      };
    case configTypes.SET_FORM_NAME:
      return {
        ...state,
        formName: action.string,
      };
    case configTypes.SET_FORM_NAME_ERROR:
      return {
        ...state,
        formNameError: action.string,
      };
    case configTypes.SET_FORM_AGENCY_NAME:
      return {
        ...state,
        formAgencyName: action.string,
      };
    case configTypes.SET_FORM_AGENCY_NAME_ERROR:
      return {
        ...state,
        formAgencyNameError: action.string,
      };
    case configTypes.SET_FORM_EMAIL:
      return {
        ...state,
        formEmail: action.string,
      };
    case configTypes.SET_FORM_EMAIL_ERROR:
      return {
        ...state,
        formEmailError: action.string,
      };
    case configTypes.SET_FORM_PHONE:
      return {
        ...state,
        formPhone: action.string,
      };
    case configTypes.SET_FORM_PHONE_ERROR:
      return {
        ...state,
        formPhoneError: action.string,
      };
    case configTypes.SET_FORM_MESSAGE:
      return {
        ...state,
        formMessage: action.string,
      };
    case configTypes.SET_FORM_MESSAGE_ERROR:
      return {
        ...state,
        formMessageError: action.string,
      };
    case configTypes.SET_FORM_CITY:
      return {
        ...state,
        formCity: action.string,
      };
    case configTypes.SET_FORM_CITY_ERROR:
      return {
        ...state,
        formCityError: action.string,
      };
    case configTypes.SET_FORM_STREET:
      return {
        ...state,
        formStreet: action.string,
      };
    case configTypes.SET_FORM_STREET_ERROR:
      return {
        ...state,
        formStreetError: action.string,
      };
    case configTypes.SET_FORM_ZIP:
      return {
        ...state,
        formZip: action.string,
      };
    case configTypes.SET_FORM_ZIP_ERROR:
      return {
        ...state,
        formZipError: action.string,
      };
    case configTypes.SET_MODAL_SUCCESS_OPEN:
      return {
        ...state,
        modalSuccessOpen: action.boolean,
      };
    case configTypes.SET_LOADING:
      return {
        ...state,
        isLoading: action.boolean,
      };
    case configTypes.SET_CONTACT_US_LOADING:
      return {
        ...state,
        isContactUsLoading: action.boolean,
      };
    case configTypes.SET_CONTACT_AGENT_LOADING:
      return {
        ...state,
        isContactAgentLoading: action.boolean,
      };
    case configTypes.SET_BECOME_AGENT_LOADING:
      return {
        ...state,
        isBecomeAgentLoading: action.boolean,
      };
    case configTypes.SET_APPLY_LOADING:
      return {
        ...state,
        isApplyLoading: action.boolean,
      };
    default:
      return state;
  }
};

export default configStore;
